import { render } from "./search-modal.vue?vue&type=template&id=3ff3963c"
import script from "./search-modal.vue?vue&type=script&lang=js"
export * from "./search-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__